export default "__VITE_ASSET__1c062bdf__"